import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { useAccessManagementDelete } from "@/hooks"
import { ErrorHelper } from "@/utils"
interface DeleteAccessManagerUserDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
  userId: string
}
export const DeleteAccessManagerUserDialog = ({
  open = false,
  setOpen,
  userId,
}: DeleteAccessManagerUserDialogProps) => {
  const { deleteUserMutation } = useAccessManagementDelete()
  const handleDelete = async (userId: string) => {
    deleteUserMutation.mutate(userId, {
      onSuccess: () => ErrorHelper.showSuccess("Usuário excluido com sucesso."),
      onError: (error) => ErrorHelper.showError(error.message),
      onSettled: () => setOpen(false),
    })
  }
  return (
    <AlertDialog onOpenChange={setOpen} open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-center text-xl">
            Deletar usuário
          </AlertDialogTitle>
          <Separator />
          <AlertDialogDescription>
            Atenção! Esta ação interfere diretamente no fluxo de acessos. Tem
            certeza que deseja excluir este usuário?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Separator />
        <AlertDialogFooter>
          <AlertDialogCancel>Voltar</AlertDialogCancel>
          <Button
            type="submit"
            variant="destructive"
            onClick={() => handleDelete(userId)}
          >
            Confirmar
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
